import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { CalendarPicker, FormControl, FormField, FormItem } from '@crossnokaye/ux-common';

import { DefrostScheduleBaseCellProps } from './defrost-schedule.types';
import { DefrostTableCell } from './defrost-table-cell';

const toStartOfDay = (date: Date): Date => {
  const day = new Date(date);
  day.setHours(0, 0, 0, 0);
  return day;
};

// TODO: Replace with ckds CalendarPicker
export const DefrostScheduleDateCell: React.FC<DefrostScheduleBaseCellProps> = ({ index }) => {
  const { control, setValue } = useFormContext();
  const fieldName = `defrostSchedule.${index}.endDate` as const;
  const todayStartOfDay = useMemo(() => toStartOfDay(new Date()), []);

  return (
    <DefrostTableCell>
      {(disabledByPermissions) => (
        <FormField
          control={control}
          name={fieldName}
          render={({ field }) => (
            <FormItem className="flex flex-col">
              <FormControl>
                <CalendarPicker
                  data-testid="defrost-schedule-end-date-picker"
                  disabled={disabledByPermissions}
                  disabledDates={(date: Date) => toStartOfDay(date) <= todayStartOfDay}
                  mode="single"
                  onSelect={(selectedDate) => {
                    setValue(fieldName, selectedDate ?? null, {
                      shouldDirty: true,
                      shouldTouch: true,
                      shouldValidate: true,
                    });
                  }}
                  placeholderText="Repeat Forever"
                  popoverContentClassName="z-overlay"
                  selected={field.value ?? undefined}
                  variant="secondary"
                  withPortal
                />
              </FormControl>
            </FormItem>
          )}
        />
      )}
    </DefrostTableCell>
  );
};
